export default {
    user: 'user',
    day: 'day',
    month: 'month',
    year: 'year'
};
